module.exports = __webpack_public_path__ + "assets/img/banner.b31dd310.png";